"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  bootstrap: true,
  firestoreBootstrap: true,
  changeDetector: true,
  ViProOnlineApi: true,
  FirestoreConnection: true,
  Guard: true
};
Object.defineProperty(exports, "ViProOnlineApi", {
  enumerable: true,
  get: function () {
    return _ViProOnlineApi.ViProOnlineApi;
  }
});
Object.defineProperty(exports, "FirestoreConnection", {
  enumerable: true,
  get: function () {
    return _FirestoreConnection.FirestoreConnection;
  }
});
Object.defineProperty(exports, "Guard", {
  enumerable: true,
  get: function () {
    return _Guard.Guard;
  }
});
exports.changeDetector = exports.firestoreBootstrap = exports.bootstrap = void 0;

var _ViProOnlineApi = _interopRequireWildcard(require("./ViProOnlineApi"));

var _FirestoreConnection = _interopRequireWildcard(require("./FirestoreConnection"));

var _changeDetector = _interopRequireDefault(require("./changeDetector"));

var _Guard = require("./Guard");

var _Models = require("./Models");

Object.keys(_Models).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Models[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/**
 * Simple bootstrap for getting things up and running quickly.
 * @returns {ViProOnlineApi} an instance of the api ready to use.
 */
const bootstrap = () => new _ViProOnlineApi.default(new _FirestoreConnection.default().connect());

exports.bootstrap = bootstrap;

const firestoreBootstrap = (serviceAccount, name, collectionName) => new _FirestoreConnection.default(serviceAccount, name, collectionName).connect();
/**
 *
 * @param {String} collection the collection to monitor
 * @param {String} id the id of the document to monitor
 * @param {Function<Object>} callback the main logic to call each time a change is detected
 */


exports.firestoreBootstrap = firestoreBootstrap;

const changeDetector = (collection, id, callback) => (0, _changeDetector.default)(collection, id, callback);

exports.changeDetector = changeDetector;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vigilantapps/vipro-online-request-manager/dist/index.js
// module id = bkPj
// module chunks = 0